export default __webpack_public_path__ + "static/media/walt-disney-logo.a21a90ed.png";